<template>
    <v-menu
            v-model="isOpen"
            ref="menu"
            transition="scale-transition"
            nudge-bottom="50"
            :close-on-content-click="false"
    >
        <template>
            <v-card class="grey lighten-4">
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>Filter configuration</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-card-text>
                    <v-select
                            v-model="form.label"
                            solo flat outlined  dense hide-details class="mb-3"
                            disabled
                            :items="[
                                    { text: form.label, value: form.label },
                                ]">
                    </v-select>
                    <v-select
                            v-model="form.operator"
                            solo flat outlined dense hide-details class="mb-3"
                            :items="operators"
                            :disabled="operators.length <= 1"
                    >
                    </v-select>
                    <v-text-field
                            solo flat outlined dense hide-details
                            v-show="form.operator !== 'exists' && form.operator !== 'notExists'"
                            ref="filterInput" autofocus
                            v-model="form.value"
                            @keypress.enter="edit()"
                    />

                </v-card-text>

                <v-divider></v-divider>

                <v-list class="grey lighten-4">
                    <v-list-item>
                        <v-list-item-action>
                            <v-switch
                                    v-model="form.isEnabled"
                                    inset color="blue"
                            ></v-switch>
                        </v-list-item-action>
                        <v-list-item-title>Enable filter</v-list-item-title>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-action>
                            <v-switch
                                    v-model="form.isExclude"
                                    inset color="red"
                            ></v-switch>
                        </v-list-item-action>
                        <v-list-item-title>Exclude filter</v-list-item-title>
                    </v-list-item>
                </v-list>

                <v-card-actions>
                    <v-btn
                            style="width: 100%;"
                            color="blue" dark
                            @click="edit()"
                    >
                        Apply
                    </v-btn>
                </v-card-actions>

            </v-card>
        </template>

        <template v-slot:activator="{ on }">
            <v-chip
                    label
                    close close-icon="mdi-close"
                    @click:close="remove()"
                    v-on="on"
                    :color="chipsColor"
                    dark small class="ma-1 filter"
            >
                <span :class="{striked: !filter.isEnabled}">{{filter | formatFilter}}</span>
            </v-chip>
        </template>
    </v-menu>

</template>

<script>
    import {mapActions} from "vuex";
    import {SEARCH_NS} from "@/store/modules/search/constants";

    export default {
        name: "FilterChip",
        props: ['filter'],
        data() {
            return {
                form: {},
                isOpen: false
            }
        },
        computed: {
            chipsColor() {
                if (!this.filter.isEnabled) {
                    return 'grey';
                }
                return this.filter.isExclude ? 'red' : 'blue';
            },
            operators() {
                return this.filter.operators || ['=', '!=', '>', '<', '>=', '<='];
            }
        },
        watch: {
            filter() {
                this.resetForm();
            },
            isOpen() {
                if(!this.isOpen) {
                    this.onCloseMenu();
                }
            }
        },
        created() {
            this.resetForm();
        },
        methods: {
            ...mapActions(SEARCH_NS, [
                'removeFilter',
                'updateFilter',
                'gotToPage'
            ]),
            onCloseMenu() {
                this.resetForm();
            },
            resetForm() {
                this.form = {
                    ...this.filter
                };
            },
            edit() {
                this.updateFilter({
                    src: this.filter,
                    filter: this.form
                }).then(() => {
                    this.isOpen = false;
                    this.gotToPage();
                });
            },
            remove() {
              this.removeFilter(this.filter)
              .then(() => this.gotToPage())
            }
        }
    }
</script>

<style scoped>
.striked {
    text-decoration: line-through
}
</style>